module.exports = __webpack_public_path__ + "img/6ea02d6.jpg";